let content_slider_blocks = document.querySelectorAll('.content-slider');

content_slider_blocks.forEach(content_slider => {

    let slider          = content_slider.querySelector('.content-slider--slider');
    let slider_controls = content_slider.querySelector('.content-slider--slider_nav');

    var cs_slider = tns({
        container: slider,
        items: 1,
        slideBy: 1,
        autoplay: false,
        nav: false,
        controlsContainer: slider_controls,
        controlsText: ['<i class="customicon-arrow-left"></i>', '<i class="customicon-arrow-right"></i>'],
        navPosition: "bottom",
        loop: false,
        onIndexChanged: highlightCurrentSlide,
        onInit: function(info) {
            highlightCurrentSlide(info);
        },
        //autoHeight: true,
    });

    cs_slider.events.on('indexChanged', highlightCurrentSlide);

    function highlightCurrentSlide(info) {
        var currentIndex = info.displayIndex - 1;
        var slides = content_slider.querySelectorAll('.tns-item');

        // Remove current-slide class from all slides
        slides.forEach(function(slide) {
            slide.classList.remove('current-slide');
        });

        // Add current-slide class to the current slide
        slides[currentIndex].classList.add('current-slide');
    }

});